import React, { useEffect, useRef } from 'react'
import CountUp from 'react-countup'
import styled from 'styled-components'

const defaultDuration = 0.5

const CountUpStyled = styled(CountUp)`
  white-space: nowrap;
`

export interface CsCountUpProps {
  start: number
  end: number
  firstDuration?: number
  duration?: number
  decimals?: number
  formatter: (value: number) => string
}

export const CsCountUp = ({ start, end, ...props }: CsCountUpProps) => {
  const prevEndRef = useRef<number>(start)

  useEffect(() => {
    if (prevEndRef.current !== end) {
      prevEndRef.current = end
    }
  }, [end])

  return (
    <CountUpStyled
      {...props}
      start={prevEndRef.current}
      end={end}
      duration={props.duration ?? defaultDuration}
      decimals={0}
      formattingFn={props.formatter}
    />
  )
}
